import type { CommercePlatform } from '@repo/types'

import { DemoLifetimeValue } from 'constants/demos'

import type { ProductPickerFormValues } from 'components/input/ProductPicker'

/**
 * The create-demo review form.
 *
 * `products` comes from `ProductPickerFormValues` rather than being redeclared,
 * so this form and the picker's contract cannot drift (VRG-369, when the picker
 * was lifted out of this folder to be shared with the Demos console's
 * Add-products modal). `ProductFormRow` itself lives with the picker.
 */
export interface ReviewFormValues extends ProductPickerFormValues {
  /**
   * VRG-723 — the GTM → Sales company the demo is for: a sales account id, or `NEW_SALES_COMPANY`
   * to create one with the demo. Picking one prefills the fields below from it.
   */
  salesAccountId: string
  /** VRG-723 — the company's industry ('' = not set); filled from a picked company. */
  industry: string
  brandName: string
  prospectDomain: string
  prospectContact: string
  sendTier: 'tier_1' | 'tier_2' | 'tier_3' | 'tier_4' | 'tier_5'
  /** VRG-716 — '' = not set. Prefilled from the propose's detection; the AE may change it. */
  commercePlatform: CommercePlatform | ''
  colorPrimary: string
  colorSecondary: string
  colorBackground: string
  fontHeading: string
  fontBody: string
  logo: string
  lifetime: DemoLifetimeValue
}

/** VRG-723 — the picker value for "create a new sales company with this demo". */
export const NEW_SALES_COMPANY = 'new'
